import {HistoryListElementType} from "../interface";
import EmptyTableRow from "../../../common/EmptyTableRow";
import React from "react";
import DisplayNumber from "../../../../components/common/number/DisplayNumber";

interface PropsType {
    historyDetail: HistoryListElementType | undefined
}

export default function Detail({historyDetail}: PropsType) {
    const type = historyDetail?.changeType === "incoming"
        ? "입고"
        : historyDetail?.changeType === "outgoing"
            ? "출고"
            : historyDetail?.changeType === "adjustment"
                ? "조정"
                : ""

    // TODO: 재고 내역 상세 카드 이미지 테이블 스크롤 필요 및 테이블이 컨테이너 밖으로 벗어남
    return <div className="right">
        {historyDetail
            ? <div className="inv_box lg">
                <div className="inv_box_top">
                    <div className="inv_box_title">{type}내역</div>
                    <div className="inv_box_toolbar">
                        <button className="btn btn-link p-0">-</button>
                    </div>
                </div>
                <div className="inv_box_content">
                    <div className="inner">
                        <div className="inv_label">
                            {type}일<br/>
                            {type}처
                        </div>
                        <div className="inv_data">
                            {historyDetail.changeAt}<br/>
                            <span>{historyDetail.accountName}</span>
                        </div>
                    </div>

                    <table className="table table-bordered my_table">
                        <thead>
                        <tr>
                            <th style={{width: "16.8%"}}>이미지</th>
                            <th style={{width: "56.03%"}}>제품 상세</th>
                            <th style={{width: "12.93%"}}>재고 변동</th>
                            <th>수량</th>
                        </tr>
                        </thead>
                        <tbody>
                        {historyDetail.eachInventoryHistoryList.length !== 0
                            ? historyDetail.eachInventoryHistoryList.map(el =>
                                <tr>
                                    <td className="p-4px">
                                        <img
                                            src={process.env.REACT_APP_SERVER_URL + `/api/file/images_download?fileKey=${el.fileKey}&fileUrl=${el.fileUrl}&fileOrgname=${el.fileOrgname}`}
                                            alt=""
                                            width={172}/>
                                    </td>
                                    <td>
                                        <div className="line1">{el.newTxtNmItem}</div>
                                        <div className="line2">{el.newTxtStndItem}</div>
                                        {(() => {
                                            const list = [
                                                el.newTxtStndItem,
                                                el.inventoryUnit,]

                                            const result = list.filter(value => value !== undefined && value !== null && value !== '').join(' / ');

                                            return <div className="line3" title={result}>{result}</div>
                                        })()}
                                    </td>
                                    <td className="text-center">{el.changeLog}</td>
                                    <td className="text-center">
                                        <>
                                            {el.changeAmount > 0 && <span className="required">+</span>}
                                            <DisplayNumber value={el.changeAmount}/>
                                        </>
                                    </td>
                                </tr>
                            )
                            : <EmptyTableRow colSpan={4}/>}
                        <tr className="blue">
                            <td className="text-center"><span className="f-15">총 품목</span></td>
                            <td><span className="f-15">{historyDetail.eachInventoryHistoryList.length}개 품목</span>
                            </td>
                            <td className="text-center"></td>
                            <td className="text-end">
                                {historyDetail.eachInventoryHistoryList.reduce((acc, cur) => acc + cur.changeAmount, 0) > 0
                                    && <span className="required">+</span>}
                                <DisplayNumber
                                    value={historyDetail.eachInventoryHistoryList.reduce((acc, cur) => acc + cur.changeAmount, 0)}/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            : <div className="d-flex justify-content-center align-items-center h-100 w-100">재고 내역을 선택해주세요.</div>
        }
    </div>
}